// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"124":"1149c5c1","234":"b2e31b3f","349":"cc1f02a1","355":"2e2370c7","530":"1e3b9765","569":"e480ea46","589":"4c7a31d0","654":"b93cae09","671":"2fcf55ec","714":"b263886e","763":"1078dedc","796":"d2343e35","800":"a948f41e"}[chunkId] + ".js";
};